export const environment = {
  version:"1.0.1",
  production: false,
  hmr: false,
  apiUrl: 'https://cadgrafics.escritoriodeayuda.com/api',
  googleClientId:
    '606336846716-4ecbgeabaku117grf3q32fnfq5ai51u2.apps.googleusercontent.com',
  pusherWsBroadcast: {
    broadcaster: 'pusher',
    key: 'WsM3s4d34yud4Br04dc4stk3y',
    cluster: 'mt1',
    wsHost: 'cadgrafics.escritoriodeayuda.com' ?? window.location.hostname,
    wsPort: 6001,
    authEndpoint: 'https://cadgrafics.escritoriodeayuda.com/api/broadcasting/auth',
    forceTLS: false,
    disableStats: true,
    encrypted: true,
  },
};


